"use client"
import CustomButton from '@/components/inputElements/ui/customButton'
import { APP_ROUTES } from '@/lib/routing/appRoutes'
import AccountTypeSelection from '@/modules/AccountTypeSection/AccountTypeSection'
import Image from 'next/image'
import { useRouter, useSearchParams } from 'next/navigation'

const SignUpPage = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const referral_code = searchParams.get('referral_code')

  return (
    <div className="min-h-screen w-full bg-[url('/assets/auth/Background.png')] bg-cover flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 h-48 lg:h-full flex items-center justify-center p-4 lg:p-0">
        <div
          className="max-w-xs lg:max-w-none"
          style={{
            animation: "logoFloat 3s ease-in-out infinite, logoFadeIn 1s ease-out",
            animationDelay: "0s, 0s",
          }}
        >
          <Image
            src="/assets/auth/Logo.svg"
            alt="Qwid Logo"
            width={400}
            height={200}
            className="logo-main w-full h-full object-contain"
            style={{
              filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))",
            }}
            priority
          />
        </div>
        <style jsx>
          {`
             @keyframes logoFloat {
               0%, 100% {
                 transform: translateY(0px) scale(1);
               }
               50% {
                 transform: translateY(-10px) scale(1.02);
               }
             }
             
             @keyframes logoFadeIn {
               0% {
                 opacity: 0;
                 transform: translateY(20px) scale(0.95);
               }
               100% {
                 opacity: 1;
                 transform: translateY(0px) scale(1);
               }
             }
           `}
        </style>
      </div>

      <div className="w-full lg:w-1/2 flex items-center justify-center p-4 lg:p-0">
        <div className="w-full max-w-md lg:max-w-none lg:h-[84%] bg-white lg:w-[84%] flex flex-col justify-center p-6 sm:p-8 lg:px-16 rounded-2xl lg:rounded-none shadow-lg lg:shadow-none">
          <AccountTypeSelection referral_code={referral_code ?? undefined} />

          <div className="text-center">
            <CustomButton
              variant="lightback"
              onClick={() => router.push(APP_ROUTES.AUTH.LOGIN)}
              className="mt-2 mb-7">
              Login Instead
            </CustomButton>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignUpPage
